<template>
    <!-- Container para toda la página: ******************************************************* -->
        <v-container fill-height fluid class="sign-in">
            <!-- Layout para toda la página: *********************************************************** -->
            <v-layout align-center justify-center>
                <!-- Flex para la ventana: **************************************************************** -->
                <v-flex xs12 sm8 md6 lg5 elevation-6>
                    <v-card class="elevation-12 pa-4" color="grey lighten-5">
                        <v-card-text>
                            <v-container grid-list-sm>
                                <v-layout row justify-space-between>
                                    <v-flex shrink>
                                        <img height="120" :src="logo1" />
                                    </v-flex>
                                </v-layout>
                                <v-divider class="light-blue darken-3"></v-divider>
                                <v-layout row justify-space-around>
                                    <v-flex shrink>
                                        <v-icon x-large color="light-blue darken-2">mdi-qrcode</v-icon>
                                    </v-flex> 
                                </v-layout>
                                <v-layout row justify-space-around>
                                    <v-flex shrink>
                                        <div class="light-blue--text text--darken-3 headline font-weight-medium">
                                            Placa de Mascota
                                        </div>
                                    </v-flex>
                                </v-layout>
    
                                <v-layout row justify-space-around>
                                    <v-flex xs12>
                                        <v-container>
                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-paw"
                                                        label="Nombre"
                                                        type="text"
                                                        v-model="petName"
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
    
                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-account"
                                                        label="Dueño"
                                                        type="text"
                                                        v-model="petOwner"
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-phone"
                                                        label="Teléfono"
                                                        type="text"
                                                        v-model="phone"
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-email"
                                                        label="Correo"
                                                        type="text"
                                                        v-model="email"
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-alert"
                                                        type="text"
                                                        v-model="sterilized"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around v-if="notes !== ''">
                                                <v-flex xs11 sm10 md9>
                                                    <v-textarea
                                                        dense
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-note-text"
                                                        :auto-grow="false"
                                                        no-resize
                                                        v-model="notes"
                                                        readonly
                                                        outlined
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs5>
                                                    <v-btn
                                                        @click="onContactOwner"
                                                        class="text-none light-blue darken-3 white--text"
                                                        :disabled="petQRError !== 0"
                                                        >
                                                        <v-icon left>
                                                            mdi-message-alert
                                                        </v-icon>
                                                        Contactar al dueño
                                                    </v-btn>
                                                </v-flex> 
                                            </v-layout>
                                                
                                        </v-container>

                                    </v-flex>
                                </v-layout>

                                <!-- Modal para informar que hay un error en la lectura del código QR: *********************************** -->
                                <v-row row justify-center>
                                    <v-dialog v-model="bQRErrorDlg" persistent :width="errorModalWidth">
                                        <v-card class="grey lighten-4">
                                            <v-toolbar dense color="orange darken-4" dark flat>
                                                <v-toolbar-title
                                                    class="my-list-title"
                                                >{{ errorMessage }}</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-icon large>mdi-qrcode</v-icon>
                                            </v-toolbar>
                                            <v-card-title>
                                                <v-container>
                                                    <v-layout row>
                                                        <v-flex xs12 class="d-flex justify-center">
                                                            <v-icon
                                                                large
                                                                color="orange darken-2"
                                                            >mdi-alert</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex
                                                            xs12
                                                            class="d-flex justify-center"
                                                        >{{  errorMessage }}</v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="teal darken-3"
                                                    class="text-none"
                                                    text
                                                    @click="bQRErrorDlg = false"
                                                >OK</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                                <!-- Termina modal para informar que hay un error en la lectura del código QR *********************************** -->

                                <!-- Modal para contactar al dueño:: *********************************** -->
                                <v-row row justify-center>
                                    <v-dialog v-model="contactOwnerDlg" persistent :width="errorModalWidth">
                                        <v-card class="grey lighten-4">
                                            <v-toolbar dense color="light-blue darken-3" dark flat>
                                                <v-toolbar-title class="my-list-title">
                                                    <v-icon large>mdi-message-alert</v-icon>
                                                    Contactar al dueño
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-toolbar-items>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn text @click="contactOwnerDlg = false" v-on="on">
                                                                <v-icon>mdi-close</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Cerrar</span>
                                                    </v-tooltip>
                                                </v-toolbar-items>
                                            </v-toolbar>
                                            <v-card-title>
                                                <v-container>
                                                    <v-layout row>
                                                        <v-flex xs12>
                                                            <v-text-field
                                                                dense
                                                                color="light-blue darken-4"
                                                                prepend-icon="mdi-map-marker"
                                                                label="Ubicación actual"
                                                                v-model="coordinates"
                                                                readonly>
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex
                                                            xs12
                                                            class="d-flex justify-center"
                                                        >
                                                            <v-textarea
                                                                dense
                                                                outlined
                                                                v-model="message"
                                                                :auto-grow="false"
                                                                no-resize
                                                                color="light-blue darken-4"
                                                                label="Mensaje"
                                                                prepend-icon="mdi-message-alert"
                                                                rows="10"
                                                                placeholder="Por favor escriba un mensaje que le haremos llegar al dueño de la mascota."
                                                                counter="300"
                                                            ></v-textarea>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="light-blue darken-3"
                                                    class="text-none light-blue darken-3 white--text"
                                                    
                                                    @click="onConfirmContactOwner"
                                                >Mandar mensaje</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                                <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                                <v-row row justify-center>
                                    <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                        <v-card class="grey lighten-4">
                                            <v-toolbar dense color="orange darken-4" dark flat>
                                                <v-toolbar-title
                                                    class="my-list-title"
                                                >Información Incompleta</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-icon>mdi-alert-circle-outline</v-icon>
                                            </v-toolbar>
                                            <v-card-title>
                                                <v-container>
                                                    <v-layout row>
                                                        <v-flex xs12 class="d-flex justify-center">
                                                            <v-icon
                                                                large
                                                                color="orange darken-2"
                                                            >mdi-alert</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex
                                                            xs12
                                                            class="d-flex justify-center"
                                                        >{{ errorMessage }}</v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="teal darken-3"
                                                    class="text-none"
                                                    text
                                                    @click="bInvalidData = false"
                                                >OK</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                                <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                                <!-- Modal para informar que el mensaje al dueño se envió con éxito *********************************** -->
                                <v-row row justify-center>
                                    <v-dialog v-model="bDlgMessageSent" persistent :width="errorModalWidth">
                                        <v-card class="grey lighten-4">
                                            <v-toolbar dense color="light-blue darken-3" dark flat>
                                                <v-toolbar-title
                                                    class="my-list-title"
                                                >Mensaje enviado</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-icon>mdi-alert-circle-outline</v-icon>
                                            </v-toolbar>
                                            <v-card-title>
                                                <v-container>
                                                    <v-layout row>
                                                        <v-flex xs12 class="d-flex justify-center">
                                                            <v-icon
                                                                large
                                                                color="orange darken-2"
                                                            >mdi-email-fast</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex
                                                            xs12
                                                            class="d-flex justify-center"
                                                        >El mensaje fue enviado con éxito.</v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="teal darken-3"
                                                    class="text-none"
                                                    text
                                                    @click="bDlgMessageSent = false"
                                                >OK</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                                <!-- Termina modal para informar que el mensaje al dueño se envió con éxito *********************************** -->

                                <!-- Modal para informar que no se pudo mandar el mensaje al dueño: *********************************** -->
                                <v-row row justify-center>
                                    <v-dialog v-model="bDlgErrorSendingMessage" persistent :width="errorModalWidth">
                                        <v-card class="grey lighten-4">
                                            <v-toolbar dense color="orange darken-4" dark flat>
                                                <v-toolbar-title
                                                    class="my-list-title"
                                                >Error en el envío del mensaje</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-icon>mdi-alert-circle-outline</v-icon>
                                            </v-toolbar>
                                            <v-card-title>
                                                <v-container>
                                                    <v-layout row>
                                                        <v-flex xs12 class="d-flex justify-center">
                                                            <v-icon
                                                                large
                                                                color="orange darken-2"
                                                            >mdi-alert</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex
                                                            xs12
                                                            class="d-flex justify-center"
                                                        >No se pudo mandar el mensaje al dueño de la mascota.</v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="teal darken-3"
                                                    class="text-none"
                                                    text
                                                    @click="bDlgErrorSendingMessage = false"
                                                >OK</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                                <!-- Termina modal para informar que no se pudo mandar el mensaje al dueño *********************************** -->


                                <!-- Termina modal para contactar al dueño *********************************** -->


                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-overlay :value="waitCursor">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
    
            <v-footer absolute color="black" dark>
                <v-spacer></v-spacer>
                <div>&copy; Grupo Tecnológico Santa Fe, S.A. de C.V. {{ new Date().getFullYear() }} &nbsp; v. {{ version }}</div>
            </v-footer>
        </v-container>
    </template>
    
    
    <script>
    import { thistle } from 'color-name';
import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                petName: '',
                petOwner: '',
                phone: '',
                email: '',
                sterilized: '',
                notes: '',

                qrCode: '',

                contactOwnerDlg: false,
                message: '',
                lat: 0,
                lng: 0,

                bInvalidData: false,
                bQRErrorDlg: false,
                errorMessage: '',
                bDlgErrorSendingMessage: false,
                bDlgMessageSent: false,
            };
        },
        
        created() {
            //this.qrCode = "eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJndHNmSldUIiwic3ViIjoiam9zZS5wYWJsb0B0cmFuc2NvbS5jb20ubXgiLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiaWF0IjoxNjc0ODU1Mzk4LCJleHAiOjE2NzQ4NjEzOTh9.p8s8bXuRly6Rmle05BGcOO47o8KGV27HBn9cnfx9quQ9TzXH6fikdwhsmtMS_cQUC9stDJ4keVxMO-7m2jGGGj";

            //Se obtiene el token de la ruta:
            this.qrCode = this.$route.params.qr;
            this.petQRInfoLoaded = false;
            this.petQRError = false;
            this.$store.dispatch('getPetQRInfo', this.qrCode)
        },

        
        methods: {
            onContactOwner() {
                this.geolocate();
                this.contactOwnerDlg = true;
            },

            onConfirmContactOwner() {

                if (this.message === '')
                {
                    this.bInvalidData = true;
                    this.errorMessage = 'Escriba un mensaje para el dueño de la mascota.';
                }
                else
                if (this.message.length > 300)
                {
                    this.bInvalidData = true;
                    this.errorMessage = 'El mensaje no puede exceder de 300 caracteres.';
                }
                else
                {
                    const messageInfo = {
                        petToken: this.qrCode,
                        latitud: this.lat,
                        longitud: this.lng,
                        mensaje: this.message
                    }

                    console.log("messageInfo = ", messageInfo);

                    this.$store.dispatch('sendMessageToOwner', messageInfo);
                    this.contactOwnerDlg = false;
                }


                
            },

            geolocate() {
                if (navigator.geolocation)
                {
                    navigator.geolocation.getCurrentPosition(
                        position => {
                            this.lat = position.coords.latitude;
                            this.lng = position.coords.longitude;
                        },
                        error => {
                            console.log("Error getting location.");
                        }
                    );
                }
                else
                {
                    console.log("Browser does not support geolocation API.");
                }
            },
        },
        computed: {
            ...mapGetters(['version', 'logo1', 'waitCursor']),
            
            petQRInfo:
            {
                get() {
                    return this.$store.getters.petQRInfo;
                },
                set(petQRInfo)
                {
                    this.$store.dispatch('updatePetQRInfo', petQRInfo);
                }
            },

            petQRInfoLoaded:
            {
                get() {
                    return this.$store.getters.petQRInfoLoaded;
                },
                set(petQRInfoLoaded)
                {
                    this.$store.dispatch('updatePetQRInfoLoaded', petQRInfoLoaded);
                }
            },

            petQRError:
            {
                get() {
                    return this.$store.getters.petQRError;
                },
                set(petQRError)
                {
                    this.$store.dispatch('updatePetQRError', petQRError);
                }
            },

            messageToOwnerRes:
            {
                get() {
                    return this.$store.getters.messageToOwnerRes;
                },
                set(petQRError)
                {
                    this.$store.dispatch('updateMessageToOwnerRes', messageToOwnerRes);
                }
            },

            coordinates() {
                return this.lat + ', ' + this.lng;    
            },
           
            errorModalWidth() {
                var width = '100%';
                if (this.$vuetify.breakpoint.xs) {
                    width = '70%';
                } else if (this.$vuetify.breakpoint.sm) {
                    width = '50%';
                } else if (this.$vuetify.breakpoint.md) {
                    width = '40%';
                } else if (this.$vuetify.breakpoint.lg) {
                    width = '30%';
                } else if (this.$vuetify.breakpoint.xl) {
                    width = '20%';
                }
                return width;
            }
        },

        watch:
        {
            petQRInfoLoaded: function(value, oldValue)
            {
                if (this.petQRInfoLoaded)
                {
                    //Pendiente: Cambiar la siguiente línea por:
                    //if (this.petQRError === 1)
                    if ((this.petQRInfo.petName === null) && (this.petQRInfo.ownerName === null))
                    {
                        console.log("petQR Error");
                        this.petQRError = 1; //Pendiente: quitar esta línea.
                        this.errorMessage = "El código QR es incorrecto.";
                        this.bQRErrorDlg = true;
                    }
                    else
                    if  (this.petQRError === 2)
                    {
                        this.errorMessage = "La membresía del dueño de la mascota está suspendida.";
                        this.bQRErrorDlg = true;
                    }
                    else
                    {
                        console.log("petQR OK");
                        this.petName = this.petQRInfo.petName;
                        this.petOwner = this.petQRInfo.ownerName;
                        this.phone = this.petQRInfo.phone;
                        this.email = this.petQRInfo.email;
                        if (this.petQRInfo.esterilizada === 0)
                        {
                            this.sterilized = "Mascota no esterilizada";
                        }
                        else
                        {
                            this.sterilized = "Mascota esterilizada";
                        }
                        this.notes = this.petQRInfo.notaPlaca;
                    } 
                }
            },

            messageToOwnerRes: function(value, oldValue)
            {
                if (this.messageToOwnerRes === 1) //Success
                {
                    this.bDlgErrorSendingMessage = false;
                    this.bDlgMessageSent = true;
                }
                else
                if (this.messageToOwnerRes === 2) //Error
                {
                    this.bDlgErrorSendingMessage = true;
                    this.bDlgMessageSent = false;
                }
            }
        }
    };
    </script>
    
    <style scoped>
    .sign-in {
        background: url('../assets/fondo1.jpg');
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    
    
    /* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
    .v-card__text,
    .v-card__title {
        word-break: normal; /* maybe !important  */
    }
    </style>